import { billingStore } from '@stores/Billing';
import { userStore } from '@stores/User';
import { useEffect } from 'react';

export const useServiceWorkerAuth = () => {
  useEffect(() => {
    // Listen for localStorage changes (when user logs in/out from other tabs)
    const handleStorageChange = (event: StorageEvent) => {
      if (event.key === 'token') {
        console.log('useServiceWorkerAuth: Token changed in localStorage');
        userStore.setToken(event.newValue);
        if (event.newValue) {
          userStore.fetch();
          // Update billing store when user logs in
          billingStore.refetchCreditsAfterOperation();
        } else {
          // Clear billing data when user logs out
          billingStore.data = null;
          billingStore.clearBillingFromLocalStorage();
        }
      }
    };

    // Listen for service worker messages (when user logs in/out from current tab)
    const handleServiceWorkerMessage = (event: MessageEvent) => {
      if (event.data && event.data.type === 'REFRESH_ACCOUNT_DETAILS') {
        console.log('useServiceWorkerAuth: REFRESH_ACCOUNT_DETAILS received');
        const localToken = localStorage.getItem('token');
        userStore.setToken(localToken);
        if (localToken) {
          userStore.fetch();
          // Update billing store when user logs in
          billingStore.refetchCreditsAfterOperation();
        } else {
          // Clear billing data when user logs out
          billingStore.data = null;
          billingStore.clearBillingFromLocalStorage();
        }
      }
    };

    // Add event listeners
    window.addEventListener('storage', handleStorageChange);
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', handleServiceWorkerMessage);
    }

    // Cleanup
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.removeEventListener('message', handleServiceWorkerMessage);
      }
    };
  }, []);
};
